import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { useDispatch } from 'react-redux';
import { apiClient, authApiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { fetchOrgRequest } from '../../../api/organizations/orgSlice';

export const mutateMfa = async ({ is_mfa_enabled }) => {
  const { data } = await authApiClient.patch('/organization/settings/account-settings', { is_mfa_enabled });
  return data;
};

export const useMutateMfaHandler = () => {
  const dispatch = useDispatch();
  const { snackbarMessages } = useTranslatedMessages();
  const settingsSnacks = snackbarMessages.settings ?? {};
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: mutateMfa,
    onSuccess: (data, variables) => {
      dispatch(fetchOrgRequest());
      queryClient.invalidateQueries({ queryKey: ['org'] });
      dispatch(
        showSnackbar({
          open: true,
          message: variables.is_mfa_enabled
            ? settingsSnacks.mfa_enabled_success || `Two-Factor Authentication enabled successfully`
            : settingsSnacks.mfa_disabled_success || `Two-Factor Authentication disabled successfully`,
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            open: true,
            message:
              error?.response?.data?.errors?.message || settingsSnacks.mfa_error || 'Failed to update MFA settings',
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            open: true,
            message: settingsSnacks.mfa_error || 'Failed to update MFA settings',
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (is_mfa_enabled) => {
    mutation.mutate({ is_mfa_enabled });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
